export default __webpack_public_path__ + "static/media/06.559f57d9.jfif";